import React from 'react';
import { ClassAssembly11B2026 } from '../views';

const ClassAssemblyPage = () => {
    return <ClassAssembly11B2026/>;
  };
  
  export default ClassAssemblyPage;